import { Price } from '../price.js';
import { TicketSupplementTemplate } from '../ticket-supplement-template.js';
import { TicketTemplate } from '../ticket-template';
import { CartItemDto } from './cart-item.js';

export abstract class TicketCartItemDto extends CartItemDto {
  public readonly originalUnitPrice: Price | null;
  public readonly unitPrice: Price;

  constructor(
    public readonly eventId: string,
    public readonly ticket: TicketTemplate,
    public readonly supplement: TicketSupplementTemplate | null,
    public readonly priceModifier: Price | null,
  ) {
    super();

    let unitPrice = ticket.price.clone();
    let originalUnitPrice = ticket.originalPrice?.clone() ?? null;

    if(priceModifier != null) {
      unitPrice = unitPrice.add(priceModifier);
      if(originalUnitPrice != null) {
        originalUnitPrice = originalUnitPrice.add(priceModifier);
      }
    }

    this.unitPrice = unitPrice;
    this.originalUnitPrice = originalUnitPrice;
  }

  get uniqueId(): string {
    return this.ticket.uniqueId;
  }

  static verifyType(item: CartItemDto): boolean {
    return item instanceof TicketCartItemDto;
  }

  static assertType(item: CartItemDto): item is TicketCartItemDto {
    return item instanceof TicketCartItemDto;
  }
}
